// Injected via webpack DefinePlugin.
declare const __BACKEND_REST_API_ADDRESS__: string;
declare const __STUDENT_LOGIN_ADDRESS__: string;

export const BackendConfig = {
    backendRestApiAddress: __BACKEND_REST_API_ADDRESS__,
    studentLoginAddress: __STUDENT_LOGIN_ADDRESS__,
};